import { useState } from 'react'
import { createProject } from '../api/client'
import type { Project } from '../types'

interface Props {
  /** Projet actuellement rattaché, pour le marquer dans la liste. */
  current: string | null
  projects: Project[]
  /** Reçoit l'id choisi, ou null pour détacher. */
  onPick: (projectId: string | null) => void
  onClose: () => void
}

/**
 * Rattacher une tâche à un projet, ou en créer un au passage.
 *
 * Ne touche pas à la tâche : il rend un id et c'est l'appelant qui décide quand
 * l'écrire. La feuille d'édition attend « Enregistrer », les listes écrivent tout
 * de suite — même composant, deux usages.
 */
export default function ProjectPicker({ current, projects, onPick, onClose }: Props) {
  const [title, setTitle] = useState('')
  const [outcome, setOutcome] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const active = projects.filter((p) => p.status === 'active')

  const create = async () => {
    const t = title.trim()
    if (!t || busy) return
    setBusy(true)
    setError(null)
    try {
      const d = await createProject({ title: t, outcome: outcome.trim() })
      onPick(d.project.id)
    } catch {
      setError('Création impossible.')
      setBusy(false)
    }
  }

  return (
    <div className="sheet" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="panel">
        <h3>Rattacher à un projet</h3>
        <div className="chips">
          <button className={'chip' + (current ? '' : ' on')} onClick={() => onPick(null)}>
            — aucun
          </button>
          {active.map((p) => (
            <button key={p.id} className={'chip' + (p.id === current ? ' on' : '')} onClick={() => onPick(p.id)}>
              {p.title}
            </button>
          ))}
        </div>

        <div className="lbl">Nouveau projet</div>
        <input value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Titre du projet" />
        <input
          value={outcome}
          onChange={(e) => setOutcome(e.target.value)}
          placeholder="Issue : à quoi ça ressemble, fini ? (optionnel)"
        />
        {error && <div className="err">{error}</div>}

        <div className="actions">
          <button className="save" onClick={() => void create()} disabled={busy || !title.trim()}>
            {busy ? 'Création…' : 'Créer et rattacher'}
          </button>
          <button className="cancel" onClick={onClose}>
            Annuler
          </button>
        </div>
      </div>
    </div>
  )
}
